import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponseWithPagination,
  SupportActionRequestsResponseDataSchema,
  SupportSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof SupportSchema>
type Response = DataResponseWithPagination<z.infer<typeof SupportActionRequestsResponseDataSchema>>

const getActionRequestsQueryKey = (query?: Query) => ["support", "actionRequests", query]

type Props = {
  query?: Query
  onSuccess?: (data: Response) => void
}

export const actionRequestsQuery = ({ query, onSuccess }: Props = {}) => {
  return queryOptions({
    queryKey: getActionRequestsQueryKey(query),
    queryFn: async () => {
      const response = await axios.get<Response>("/support/entities/action-requests", {
        params: query,
      })

      onSuccess?.(response.data)

      return response.data.data
    },
  })
}
